import { getConsoleStyle } from './styledLogs';
const logStyled = (message) => console.log('%c%s', getConsoleStyle(), message);
export const weAreHiring = () => {
    const message = 'You are a Developer? RIO is hiring!\nhttps://company.rio.cloud/en/career/jobs';
    logStyled(message);
};
